import styled from 'styled-components';

export const TestimonialContainer = styled.section`
  padding: 2rem 0;
  min-height: 30vh;
  background-color: ${(props) => props.theme.background};
  display: flex;
  justify-content: center;
  margin-bottom: -7rem;

  @media (max-width: 768px) {
    margin-bottom: -3rem;
  }
`;

export const Author = styled.h3`
  font-size: 1rem;
  font-weight: bold;
  color: ${(props) => props.theme.text};
`;



export const TestimonialContent = styled.div`
  max-width: 800px;
  text-align: center;

  

  blockquote {
    font-size: 1.25rem;
    font-style: italic;
    margin-bottom: 1rem;
    color: ${(props) => props.theme.text};
  }

  ${Author} {
    font-weight: bold;
    color: ${(props) => props.theme.text};
  }
`;